import PropTypes from 'prop-types'

import { kea } from 'kea'
import railsContext from 'lib/selectors/rails-context'

export default kea({
  actions: () => ({
    closeModal: true,
    updateAvatar: avatar => ({ avatar })
  }),

  reducers: ({ actions }) => ({
    isCloseModal: [
      false,
      PropTypes.bool,
      {
        [actions.closeModal]: () => true
      }
    ],
    avatar: [
      '',
      PropTypes.string,
      {
        [actions.updateAvatar]: (_, { avatar }) => avatar
      }
    ]
  }),

  selectors: () => ({
    id: [() => [railsContext], ({ currentUserId }) => currentUserId, PropTypes.number]
  })
})
